import React, {useEffect, useState} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {
    getInitialSidebarOpenState,
    getSavedSidebarOpenState,
    isMobileSidebarLayout,
    persistSidebarOpenState
} from "./appNavigationModel";
import SidebarNavigationView from "./SidebarNavigationView";
import BottomNavigationView from "./BottomNavigationView";

export default function AppNavigation({getLinksData}) {
    const location = useLocation();
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [isMenuOpen, setIsMenuOpen] = useState(() => getInitialSidebarOpenState(window.innerWidth));
    const history = useHistory();
    const isMobileLayout = isMobileSidebarLayout(screenWidth);
    const links = getLinksData ? getLinksData() : [];

    useEffect(() => {
        const handleResize = () => {
            setScreenWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (isMobileLayout) {
            setIsMenuOpen(true);
        } else {
            setIsMenuOpen(getSavedSidebarOpenState());
        }
    }, [isMobileLayout]);

    const navigateToLink = (href) => (e) => {
        e.preventDefault();

        if (!href) {
            return;
        }

        history.push(href);
    };

    const toggleOpenMenu = () => {
        changeOpenMenu(!isMenuOpen);
    };

    const changeOpenMenu = (isOpen) => {
        setIsMenuOpen(isOpen);
        persistSidebarOpenState(isOpen);
    };

    return (
        isMobileLayout
            ? <BottomNavigationView
                currentPath={location.pathname}
                links={links}
                onNavigateToLink={navigateToLink}
            />
            : <SidebarNavigationView
                currentPath={location.pathname}
                isMenuOpen={isMenuOpen}
                links={links}
                onToggleOpenMenu={toggleOpenMenu}
                onNavigateToLink={navigateToLink}
            />
    );
}


